/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Bypass_Slowmode_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to send messages without being affected by slowmode." |
*
* @param {Leveling_Perm_Bypass_Slowmode_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_bypass_slowmode_hint = /** @type {((inputs?: Leveling_Perm_Bypass_Slowmode_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Bypass_Slowmode_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам отправлять сообщения без ограничений медленного режима.")
	return /** @type {LocalizedString} */ ("Allows members to send messages without being affected by slowmode.")
});